<template>
  <div>
    <div class="main-title">用户列表</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" @click="add">添加用户</el-button>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索手机号、姓名"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              @input="inputSearch(searchForm)">
            </el-input>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        :row-class-name="tableRowClassName"
        style="width:100%">
        <el-table-column prop="username" label="手机号"/>
        <el-table-column prop="realname" label="姓名"/>
        <el-table-column prop="rolename" label="角色"/>
        <el-table-column label="所属科目">
          <template slot-scope="scope">
            {{ parseCompanys(scope.row.company_ids) }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            {{ scope.row.is_del === '0' ? '正常' : '禁用' }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
            <el-button type="text" @click="reset(scope.row)">重置密码</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total"
        :total="total">
      </el-pagination>
    </div>
    <!-- 用户添加 -->
    <el-dialog :title="form.id > 0 ? '修改用户信息' : '添加新用户'" :visible.sync="formVisible">
      <el-form :model="form" ref="form" :rules="formRules" label-width="200px">
        <el-form-item prop="username" label="手机号">
          <el-input v-model="form.username" style="width:194px;" :disabled="form.id > 0"></el-input>
        </el-form-item>
        <el-form-item prop="realname" label="姓名">
          <el-input v-model="form.realname" style="width:194px;" :disabled="form.id > 0"></el-input>
        </el-form-item>
        <el-form-item prop="role_id" label="角色">
          <el-select
            v-model="form.role_id"
            placeholder="请选择一个角色"
            style="width:194px;">
            <el-option
              v-for="item in roleList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="company_ids" label="所属科目">
          <el-checkbox-group v-model="form.company_ids">
            <el-checkbox v-for="item in companyList" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="状态" v-if="form.id > 0">
          <el-radio-group v-model="form.is_del">
            <el-radio label="0">正常</el-radio>
            <el-radio label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="commit" :loading="commiting"> 确定 </el-button>
        <el-button @click="formVisible = false"> 取消 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
export default {
  mixins: [ListFunc],
  data () {
    return {
      sqlcode: 'user_list',
      pageSize: 0,
      groupList: [],
      companyList: [],
      roleList: [],
      searchForm: {
        query: ''
      },
      form: {
        id: 0,
        username: '',
        realname: '',
        role_id: null,
        is_del: '0',
        company_ids: []
      },
      formVisible: false,
      commiting: false,
      formRules: {
        username: [
          { required: true, message: "请填写手机号", trigger: "blur" },
          { min: 11, max: 11, message: "手机号格式错误", trigger: 'blur' }
        ],
        realname: [
          { required: true, message: "请填写姓名", trigger: "blur" }
        ],
        role_id: [
          { required: true, message: "请选择角色", trigger: "blur" }
        ],
        company_ids: [
          { required: true, message: "请选择所属科目", trigger: "blur" }
        ]
      }
    }
  },
  mounted () {
    this.fetchCompanyList()
    this.fetchRoleList()
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (row.is_del !== '0') {
        return 'row-red'
      }
      return ''
    },
    parseCompanys (companys) {
      try {
        let arr = JSON.parse(companys)
        arr = arr.map(a => {
          let b = this.companyList.filter(c => c.value === a)
          if (b.length > 0) {
            return b[0].label
          }
          return ''
        })
        return arr.join(',')
      } catch (e) {
        return ''
      }
    },
    fetchCompanyList () {
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
        }
      })
    },
    fetchRoleList () {
      this.$http.get('/dbapi/role_combo').then(response => {
        if (response.data.success) {
          this.roleList = response.data.list
        }
      })
    },
    add () {
      this.form = {
        id: 0,
        username: '',
        realname: '',
        role_id: null,
        is_del: '0',
        company_ids: []
      }
      this.formVisible = true
    },
    edit (row) {
      this.form = {
        id: row.id,
        username: row.username,
        realname: row.realname,
        role_id: row.role_id,
        is_del: row.is_del,
        company_ids: JSON.parse(row.company_ids)
      }
      this.formVisible = true
    },
    commit () {
      let form = { ...this.form }
      form.company_ids = JSON.stringify(form.company_ids)
      this.$refs.form.validate(valid => {
        if (valid) {
          let url = '/dbapi/insert_user'
          if (this.form.id > 0) {
            url = '/dbapi/update_user'
          }
          this.commiting = true
          this.$http.post(url, form).then(response => {
            this.commiting = false
            if (response.data.success) {
              this.$message({
                type: 'success',
                message: '操作成功'
              })
              this.formVisible = false
              this.refresh()
            }
          })
        }
      })
    },
    reset (row) {
      this.$confirm('确定要重置这个用户的密码吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/user_reset_pass', { id: row.id }).then(response => {
          if (response.data.success) {
            this.$message({
              type: 'success',
              message: '密码重置成功,新密码为123456,请登录后尽快修改密码'
            })
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sys/User.vue